import { tenantQuotingSettingsQuery } from "@common/api/quoting/settings"
import { useQuery } from "@tanstack/react-query"

export function usePhasesEnabled(): boolean {
  const { data } = useQuery(tenantQuotingSettingsQuery())
  return data?.phases_enabled ?? false
}
